import { render, staticRenderFns } from "./LocationDefaultSettings.vue?vue&type=template&id=3ae5bc56&scoped=true&"
import script from "./LocationDefaultSettings.vue?vue&type=script&lang=js&"
export * from "./LocationDefaultSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae5bc56",
  null
  
)

export default component.exports